import type { AccessTag, Fest, FestKind, OvernightKind } from "../types";

export const KIND_LABELS: Record<FestKind, string> = {
  haunt: "Ghosts / haunts",
  cryptid: "Cryptids / Bigfoot",
  ufo: "UFO / UAP",
};

export const KIND_COLORS: Record<FestKind, { color: string; fill: string }> = {
  haunt: { color: "#FA5468", fill: "#172B2D" },
  cryptid: { color: "#68AAA0", fill: "#2D92A4" },
  ufo: { color: "#F6BB51", fill: "#E2991A" },
};

export const TAG_LABELS: Record<AccessTag, string> = {
  "on-site-camp": "Camp on site",
  "nearby-camp": "Camp nearby",
  "rv-friendly": "RV-friendly",
  "overnight-hunt": "Overnight hunt",
  museum: "Museum / site",
  festival: "Festival",
  "night-watch": "Night watch",
  "year-round": "Year-round",
};

export function primaryKind(fest: Fest): FestKind {
  return fest.kinds[0] ?? "haunt";
}

export function kindLabel(fest: Fest): string {
  return fest.kinds.map((k) => KIND_LABELS[k]).join(" · ");
}

export function overnightLabel(kind: OvernightKind): string {
  if (kind === "on-site") return "Sleep on site";
  if (kind === "nearby") return "Camp nearby";
  return "Day trip / hotels";
}

export function matchesFilters(
  fest: Fest,
  filters: {
    region: Fest["region"] | "";
    kind: FestKind | "";
    camp: boolean;
    rvFriendly: boolean;
  },
): boolean {
  if (filters.region && fest.region !== filters.region) return false;
  if (filters.kind && !fest.kinds.includes(filters.kind)) return false;
  if (filters.camp && fest.overnight === "day-trip") return false;
  if (filters.rvFriendly && !fest.rvFriendly) return false;
  return true;
}
